export default {
    getUser: (state: any): any => state.user,
    getUserUi: (state: any): any => state.user.ui,
};